/* BEEA community stories: circles open a full-screen viewer. Tap or arrows to move, hold to pause, swipe down or Esc to close. One video loads at a time. */
(function () {
  'use strict';
  var B = window.BEEA || {}, D = B.devices || {}, T = B.t || {};
  var row = document.getElementById('stRow'), V = document.getElementById('stv'), el = document.getElementById('stData');
  if (!row || !V || !el) return;
  var data = [];
  try { data = JSON.parse(el.textContent); } catch (e) { data = []; }
  data = data.filter(function (x) { return x && (x.v || x.i); });
  if (!data.length) { row.closest('section').hidden = true; return; }

  var ORDER = ['glam', 'aura', 'facegym', 'rems', 'sculpta', 'vita'];
  var sets = { all: data };
  ORDER.forEach(function (k) { sets[k] = data.filter(function (x) { return x.d === k; }); });
  var chain = ORDER.filter(function (k) { return sets[k].length; });

  var SK = 'beea_stories_seen', seen = {};
  try { seen = JSON.parse(localStorage.getItem(SK) || '{}') || {}; } catch (e) { seen = {}; }
  var key = function (x) { return String(x.v || x.i).split('?')[0].split('/').pop(); };
  function markRow() {
    [].forEach.call(row.querySelectorAll('.st-c'), function (c) {
      var s = sets[c.dataset.set] || [];
      c.hidden = !s.length;
      var n = c.querySelector('.st-n'); if (n) n.textContent = s.length;
      c.classList.toggle('seen', s.length > 0 && s.every(function (x) { return seen[key(x)]; }));
    });
  }
  markRow();

  var $ = function (s) { return V.querySelector(s); };
  var vid = $('.stv-v'), img = $('.stv-i'), bars = $('.stv-bars'), cap = $('.stv-cap'), shop = $('.stv-shop'), add = $('.stv-shop .add');
  var devTh = $('.stv-dev .th'), devName = $('.stv-dev b'), muteBtn = $('.stv-mute'), frame = $('.stv-frame');
  var ICON_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9.5l4 5M21 9.5l-4 5"/></svg>';
  var ICON_ON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>';
  var STILL = 5000, cur = 'all', ci = 0, raf = 0, paused = false, muted = true, lastFocus = null, stillEl = 0, lastT = 0;
  var money = function (c) { return window.BEEAcart && BEEAcart.money ? BEEAcart.money(c) : ''; };

  function setMute(m) {
    muted = m; vid.muted = m;
    muteBtn.innerHTML = m ? ICON_OFF : ICON_ON;
    muteBtn.setAttribute('aria-pressed', String(!m));
    muteBtn.setAttribute('aria-label', m ? (T.sound_on || 'Sound on') : (T.sound_off || 'Sound off'));
  }
  function renderBars() { bars.innerHTML = sets[cur].map(function () { return '<i><b></b></i>'; }).join(''); }
  function setBar(p) {
    [].forEach.call(bars.children, function (e, j) { e.firstChild.style.width = (j < ci ? 100 : j > ci ? 0 : Math.max(0, Math.min(100, p * 100))) + '%'; });
  }
  function loop(now) {
    var x = sets[cur][ci], p = 0;
    if (x.v) { p = vid.duration ? vid.currentTime / vid.duration : 0; }
    else {
      if (!paused) stillEl += now - (lastT || now);
      lastT = now; p = stillEl / STILL;
      if (p >= 1) { next(); return; }
    }
    setBar(p);
    raf = requestAnimationFrame(loop);
  }
  function show() {
    cancelAnimationFrame(raf);
    var x = sets[cur][ci], dv = D[x.d];
    seen[key(x)] = 1; try { localStorage.setItem(SK, JSON.stringify(seen)); } catch (e) {}
    devTh.style.backgroundImage = dv ? 'url(' + dv.img + ')' : '';
    devTh.hidden = !dv;
    devName.textContent = dv ? dv.name : (T.community || '');
    cap.textContent = x.t || '';
    if (dv) {
      shop.hidden = false;
      shop.querySelector('.th').style.backgroundImage = 'url(' + dv.img + ')';
      shop.querySelector('.th').href = shop.querySelector('.nm').href = dv.url;
      shop.querySelector('b').textContent = dv.name;
      shop.querySelector('em').textContent = money(dv.price);
      add.dataset.add = x.d; add.hidden = !(dv.available && dv.variant);
    } else { shop.hidden = true; add.dataset.add = ''; }
    paused = false; stillEl = 0; lastT = 0;
    if (x.v) {
      img.hidden = true; vid.hidden = false;
      vid.poster = x.p || ''; vid.src = x.v; vid.muted = muted;
      var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
    } else {
      vid.pause(); vid.removeAttribute('src'); vid.hidden = true;
      img.src = x.i; img.hidden = false;
    }
    setBar(0);
    var n = sets[cur][ci + 1]; if (n && (n.p || n.i)) { var im = new Image(); im.src = n.p || n.i; }
    raf = requestAnimationFrame(loop);
  }
  function open(set, i) {
    lastFocus = document.activeElement; cur = set; ci = i || 0;
    V.hidden = false; document.documentElement.classList.add('st-open');
    renderBars(); setMute(muted); show();
    var x = V.querySelector('.stv-x'); x && x.focus();
  }
  function close() {
    cancelAnimationFrame(raf); vid.pause(); vid.removeAttribute('src'); try { vid.load(); } catch (e) {}
    V.hidden = true; document.documentElement.classList.remove('st-open'); markRow();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function next() {
    if (ci < sets[cur].length - 1) { ci++; show(); return; }
    var k = cur === 'all' ? null : chain[chain.indexOf(cur) + 1];
    if (k) { cur = k; ci = 0; renderBars(); show(); } else close();
  }
  function prev() {
    if (ci > 0) { ci--; show(); return; }
    var k = cur === 'all' ? null : chain[chain.indexOf(cur) - 1];
    if (k) { cur = k; ci = sets[k].length - 1; renderBars(); show(); } else { ci = 0; show(); }
  }
  function pause(p) { paused = p; if (sets[cur][ci].v) { if (p) vid.pause(); else { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); } } }

  vid.addEventListener('ended', next);
  row.addEventListener('click', function (e) { var c = e.target.closest('.st-c'); if (c) open(c.dataset.set, 0); });
  muteBtn.addEventListener('click', function () { setMute(!muted); if (!muted && sets[cur][ci].v) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); } });

  /* hold to pause; a short press on the left or right third moves; swipe sideways moves, swipe down closes */
  var hold = 0, held = false, sx = 0, sy = 0, swiped = false;
  frame.addEventListener('pointerdown', function (e) {
    if (e.target.closest('.stv-top,.stv-shop')) return;
    held = false; hold = setTimeout(function () { held = true; pause(true); }, 220);
  });
  var release = function () { clearTimeout(hold); if (held) { pause(false); } };
  frame.addEventListener('pointerup', release);
  frame.addEventListener('pointercancel', release);
  frame.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; swiped = false; }, { passive: true });
  frame.addEventListener('touchend', function (e) {
    var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
    if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { swiped = true; close(); }
    else if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { swiped = true; dx < 0 ? next() : prev(); }
  }, { passive: true });
  V.addEventListener('click', function (e) {
    if (swiped) { swiped = false; return; }
    if (held) { held = false; return; }
    if (e.target === V || e.target.closest('[data-stclose]')) { close(); return; }
    if (e.target.closest('[data-stnext]')) { next(); return; }
    if (e.target.closest('[data-stprev]')) { prev(); }
  });
  document.addEventListener('keydown', function (e) {
    if (V.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') next();
    else if (e.key === 'ArrowLeft') prev();
    else if (e.key === ' ' && e.target === document.body) { e.preventDefault(); pause(!paused); }
  });
  document.addEventListener('visibilitychange', function () { if (!V.hidden && document.hidden) pause(true); });
})();
